import React from 'react';
import PreHeader from '../Components/landing/PreHeader';
import Header from '../Components/landing/Header';
import Hero from '../Components/landing/Hero';
import Screenshots from '../Components/landing/Screenshots';
import Why from '../Components/landing/Why';
import HowItWorks from '../Components/landing/HowItWorks';
import Pricing from '../Components/landing/Pricing';
import FAQ from '../Components/landing/FAQ';
import Footer from '../Components/landing/footer';
import './LandingPage.css';

function LandingPage() {
  return (
    <div className="landing-root">
      <PreHeader />
      <Header />
      <Hero />
      <Screenshots />
      <Why />
      <HowItWorks />
      <Pricing />
      <FAQ />
      <Footer />
    </div>
  );
}

export default LandingPage;
